import { render } from "./SortingOfWorks.vue?vue&type=template&id=c7666ed2&scoped=true"
import script from "./SortingOfWorks.vue?vue&type=script&lang=js"
export * from "./SortingOfWorks.vue?vue&type=script&lang=js"

import "./SortingOfWorks.vue?vue&type=style&index=0&id=c7666ed2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7666ed2"]])

export default __exports__